(function ($) {
	'use strict';
	var pluginName = 'cSelect';

	var defaults = {
		class : 'cSelect ',
		placeholder_class : 'first_option',
		disabled_class    : 'select-disabled',
		option_attr_name  : 'use_option_attr'
	};

	function _update(self) {
		var first = $('option', self.$element).first();
		var selectedOption = $('option:selected', self.$element);
		var option = selectedOption.length ? selectedOption : first;
		var text = (self.option_attr && option.data(self.option_attr)) ? option.data(self.option_attr) : option.text();
		self.$label.html(text);
		if (self.$element.prop('disabled')) {
			self.$wrapper.addClass(self.options.disabled_class);
		} else {
			self.$wrapper.removeClass(self.options.disabled_class);
		}
		if (first.val() === selectedOption.val() && first.text() === selectedOption.text()){
			self.$label.addClass(self.options.placeholder_class);
		} else {
			self.$label.removeClass(self.options.placeholder_class);
		}
	}

	function Plugin(element, options) {
		this.element = element;
		this.$element = $(element);
		this.options = $.extend(true, {}, defaults, options);
		this.option_attr = (this.$element.data(this.options.option_attr_name));
		this.id = this.$element.attr("id") || "";
		var withSearch = (this.$element.attr("data-search") === "true");

		var wrapper_classList = this.options.class + ' ' + (this.$element.prop("disabled") ? this.options.disabled_class : "");
		var wrapper = ("<div class='" + wrapper_classList + "' data-id='" + this.id + "' data-type='cSelect' data-search='" + withSearch + "'></div>");
		this.$label = $("<div></div>");
		this.$search = withSearch ? this.getSearchInput() : null;
		this.$element.wrap(wrapper);
		this.$wrapper = this.$element.parent();

		this.$wrapper
			.prepend(this.$search)
			.prepend(this.$label);

		if (withSearch) {
			this.addSearchEventListeners();
		}

		this.init();
	}

	Plugin.prototype.init = function () {
		var self = this;
		self.update();
		self.$element.on('change update', function(ev){_update(self);});
	};

	Plugin.prototype.update = function () {
		_update(this);
	};

	Plugin.prototype.getSearchInput = function getSearchInput() {
		var $container = $("<div>");
		var placeholderText = this.$element.attr("data-search-text");

		if (placeholderText === null) {
			placeholderText = "Search...";
		}

		var $search = $("<input>")
			.addClass("cSelect-search")
			.attr({
				placeholder: placeholderText,
				type: "text",
				id: "cSelect-search-" + this.id,
				list: "cSelect-list-" + this.id
			});
		
		var $icon = $("<span>")
			.addClass("cSelect-search-icon")
			.append($("<span>")
				.addClass("icon-mglass")
			);
		
		var $list = $("<datalist>")
			.attr("id", "cSelect-list-" + this.id);

		$list.append(this
			.$element
			.find("option")
			.clone()
			.filter(function() {
				return $(this).attr("value");
			})
			.attr("value", function() {
				return $(this).text();
			})
			.text("")
		);

		$container
			.append($search)
			.append($icon)
			.append($list);

		return $container.children();
	}

	Plugin.prototype.addSearchEventListeners = function() {
		var className = this.options.class;

		this.$wrapper.on("click", ".cSelect-search-icon", function() {
			$(this)
				.closest("." + className)
				.addClass("search-input-visible")
				.find(".cSelect-search")
				.val("")
				.focus()
			;
		});
	
		this.$wrapper.on("focusout", ".cSelect-search", function() {
			$(this)
				.closest("." + className)
				.removeClass("search-input-visible")
			;
		});
	
		this.$wrapper.on("change", ".cSelect-search", function() {
			var $select;
			var valueName = $(this).val();
			var valueId;
	
			$select = $(this)
				.closest("." + className)
				.find("select")
			;
	
			valueId = $select
				.find("option")
				.filter(function() {
					return $(this).text() === valueName;
				})
				.first()
				.attr("value")
			;
	
			$select
				.val(valueId || "")
				.change();
		});
	}

	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));
			} else {
				$(this).data('plugin_' + pluginName).update();
			}
		});
	};
}(jQuery));